import React from "react";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';
import Typography from "@material-ui/core/Typography";
const HtmlTooltip = makeStyles((theme) => ({
    arrow: {
        color: "gray",
        fontSize:20
      },
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))
  function BootstrapTooltip(props) {
    const classes = HtmlTooltip();
  
    return <Tooltip arrow classes={classes} {...props} />;
  }
  export default function CustomTooltip ({children}){
    return(
        <BootstrapTooltip
        title={
        <React.Fragment>
        <Typography color="inherit">Password Guidelines</Typography>
        <b>{"Your password must have: "}</b> <br/>
        {/* <b>{'some'}</b> <u>{'amazing content'}</u>.{' '} */}
        <li>{"8 or more characters"}</li>
        <li>{"Upper & lowercase letters"}</li>
        <li>{"At least one number"}</li>
        <li>{"At least one special character"}</li>
        </React.Fragment>
        }
       >
       {children}
       </BootstrapTooltip>
    )
  }